module.exports = __webpack_public_path__ + "media/images/illustration/undraw_coming_home_52ir-8738bc3e9d1248aadc68aa3cba7319e2.svg";